import React from "react";
import { Modal, Button, Tooltip, theme } from "antd";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL, URL_LAB } from "../../constants/urls";
import { LAB_ORDER_TYPE, LAB_STATUS } from "../../constants/string";
import { useNavigate } from "react-router-dom";
import * as _ from "lodash";
import { dateTimeToHumanString, formatComma } from "../../frameworks/Util";
import {
  VerticalAlignBottomOutlined,
} from '@ant-design/icons';
import { GET } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";
import LabAddChemicalModal from "../../components/lab-latex/LabAddChemicalModal";


export default function TankLabModal({
  open=false,
  onCancel=() => null,
}) {
  const [ fillTarget, setFillTarget ] = React.useState(null);
  const [ fillChemical, setFillChemical ] = React.useState(null);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const { token : { colorSuccess }} = theme.useToken();
  const tableRef = React.useRef();
  const navigate = useNavigate();
  const columnChemicalWidth = 60;

  const refreshData =() => {
    if(tableRef.current){
      tableRef.current.fetchWithoutResetPage();
    }
  }

  const fetchChemical = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(URL_CHEMICAL.QUALITY_CHEMICAL, {ordering : 'name'})
      setFillChemical(response.data.results);
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }
  
  const columns = [
    {
      title : 'Action',
      dataIndex : 'ref',
      render : (value, original) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip triger='hover' title={"เติมสารเคมี"}>
            <ColorButton 
              type='primary'
              override={colorSuccess}
              style={{ margin : 5}}
              icon={<VerticalAlignBottomOutlined />}
              onClick={()=> setFillTarget(original)} 
            />
          </Tooltip>
        </div>
      )
    },
    {
      title: 'แทงก์',
      dataIndex: 'ref_detail',
      render: (value) => _.get(value, 'tank_name', '-')
    },
    {
      title: 'Lot no.',
      dataIndex: 'ref_detail',
      render: (value) => _.get(value, 'lot_no', '-'),
    },
    {
      title: 'Example No.',
      width: 130,
      dataIndex: 'code',
      key: 'code',
      searcher : true
    },
    {
      title: 'ตักตัวอย่าง',
      render: (__, original) => (
        <center>
          <div>{dateTimeToHumanString(_.get(original, 'created', '-'))} </div>
          <div>{`(${_.get(original, 'created_by_name', '-')})`}</div>
        </center>
      )
    },
    {
      title: 'ผู้ลงผลแล็บ',
      render: (__, original) => (
        <center>
          <div>{dateTimeToHumanString(_.get(original, 'lab_datetime', '-'))} </div>
          <div>{`(${_.get(original, 'lab_user_name', '-')})`}</div>
        </center>
      )
    },
    {
      title: <center>สารเคมีที่ต้องเติม</center>,
      dataIndex: 'age',
      key: 'age',
      children: [..._.filter(fillChemical,({tank : true}), []).map((data) => {
        return {
          title : <center>{data.name}</center> ,
          dataIndex: data.name,
          width: columnChemicalWidth,
          key: data.id,
          render : (value, original) => {
            const findData = (_.find(_.get(original, 'inputs' , []), { 'chemical': _.get(data, 'name' , '')} ))
            if(findData){
                 return <center>{formatComma(_.get(findData, 'amount' , '-'))}</center>
            } else return <center> - </center>
            }
          }
        }
      )]
    }]

  React.useEffect(() => {
    if(open && tableRef.current) {
      tableRef.current.fetch();
    }
  }, [open])

  React.useEffect(() => {
      fetchChemical()
  },[])

  return (
    <div>
      <Modal
        title='แล็บแทงก์'
        open={open}
        onCancel={onCancel}
        width={1000}
        footer={[
          <Button onClick={onCancel}>ปิด</Button>
        ]}
      >
        <ErrorMessages message={errorMessages}/>
        <TSTable
          ref={tableRef}
          columns={columns}
          autoFetch={false}
          url={URL_LAB.LAB_ORDER}
          params={{ status: LAB_STATUS.INPUT_PROGRESSING, type: LAB_ORDER_TYPE.TANK }}/>
      </Modal>
      <LabAddChemicalModal
        open={fillTarget ? true : false}
        onClose={() => setFillTarget(false)}
        onUpdate={() => {
          setFillTarget(false);
          refreshData();
        }}
        target={fillTarget}
      />
    </div>
  )
}